<script lang="ts">
	export let firstWidth = '21px';
	export let chevronLeft = '18px';
	export let chevronTop = '-5px';
	export let dividerOffset = '35px';
</script>

<div class="crazy-divider-container d-flex justify-content-between">
	<div class="crazy-divider-first" style="width: {firstWidth};"></div>
	<i class="fa-light fa-chevron-down" style="left: {chevronLeft}; top: {chevronTop};"></i>
	<div class="crazy-divider-divider" style="width: calc(100% - {dividerOffset});"></div>
</div>

<style>
	.crazy-divider-container {
		position: relative;
		width: 100%;
	}

	.crazy-divider-first {
		border-bottom: 1px solid #303235;
	}

	.crazy-divider-container > i {
		position: absolute;
		color: #303235;
	}

	.crazy-divider-divider {
		border-bottom: 1px solid #303235;
	}
</style>
